import {none, option, Option} from "ts-option";
import User from "../user/User";
import {getUser} from "../../store/view/user";
import * as moment from "moment";
import AuthenticatedEntity, {AuthenticatedEntityTypeEnum} from "../user/AuthenticatedEntity";
import {PinningDataApiDto} from "../../api/model/rest";

/**
 * Note pinning data model
 */
export default class PinningData {
	/**
	 * User details.
	 */
	userDetails: Option<User> = none;
	constructor(public readonly pinned: boolean,
		public readonly pinningDate: Option<moment.Moment>,
		public readonly userWhoPinned: Option<AuthenticatedEntity>) {
		this.userDetails = getUser(userWhoPinned.map(u => u.id).orNull);
	}

	static fromJson(json: PinningDataApiDto): PinningData {
		const userWhoPinned = json.userWhoPinned ? option(AuthenticatedEntity.fromJson(json.userWhoPinned)) : none;
		const pinningDate = json.pinningDate ? option(moment(json.pinningDate)) : none;
		return new PinningData(json.pinned, pinningDate, userWhoPinned);
	}

	getUserDisplayName(): string {
		if (this.userWhoPinned.map(u => u.type).orNull === AuthenticatedEntityTypeEnum.User) {
			return this.userDetails.map(u => u.getDisplayName()).getOrElse(this.userWhoPinned.get.id);
		}
		else {
			return this.userWhoPinned.map(u => u.id).orNull;
		}
	}

	getCreationDate(): Option<moment.Moment> {
		return this.pinningDate;
	}
}

